import { Backgrounds } from '@/features/MotionGraphicsZones/icons/backgrounds';
import { Buttons } from '@/features/MotionGraphicsZones/icons/buttons';
import { Cinematic } from '@/features/MotionGraphicsZones/icons/cinematic';
import { Intros } from '@/features/MotionGraphicsZones/icons/intros';
import { LowerThirds } from '@/features/MotionGraphicsZones/icons/lower-thirds';
import { Overlays } from '@/features/MotionGraphicsZones/icons/overlays';
import { Titles } from '@/features/MotionGraphicsZones/icons/titles';
import { Transitions } from '@/features/MotionGraphicsZones/icons/transitions';
import { BellRing, ChartPie, Smile } from '@music-vine/cadence/icons';
import { TextParagraph } from '../Icons/Text';
export const POPULAR_MG_ICONS = [{
  id: 0,
  name: 'Animations',
  icon: Cinematic
}, {
  id: 1,
  name: 'Backgrounds',
  icon: Backgrounds
}, {
  id: 2,
  name: 'Buttons',
  icon: Buttons
}, {
  id: 3,
  name: 'Icons',
  icon: BellRing
}, {
  id: 4,
  name: 'Infographics',
  icon: ChartPie
}, {
  id: 5,
  name: 'Intros',
  icon: Intros
}, {
  id: 6,
  name: 'Lower thirds',
  icon: LowerThirds
}, {
  id: 7,
  name: 'Overlays',
  icon: Overlays
}, {
  id: 8,
  name: 'Stickers',
  icon: Smile
}, {
  id: 9,
  name: 'Text',
  icon: TextParagraph
}, {
  id: 10,
  name: 'Titles',
  icon: Titles
}, {
  id: 11,
  name: 'Transitions',
  icon: Transitions
}];